import React from 'react';
import './Dashboard.css';
import { Container, Row, Col } from 'react-bootstrap';
import { Highlights, Earnings, MyTasks } from '../../components';

const Dashboard = () => {
    return (
        <Container fluid>
            <Row>
                <Col>
                    <h1 className="display-1">Dashboard</h1>
                    <div className="display-2">Central Hub for Personal Customization</div>
                </Col>
            </Row>
            <Row className="mt-0 gy-4">
                <Col lg={4}>
                    <Highlights />
                </Col>
                <Col lg={8}>
                    <Earnings />
                </Col>
                <Col lg={12}>
                    <MyTasks />
                </Col>
            </Row>
        </Container>  
    );
};

export default Dashboard;
